const socialLinks = [
  {
    name: "Instagram",
    description: "تابع أخبارنا ومشاريعنا",
    href: "#",
    icon: "instagram",
  },
  {
    name: "X",
    description: "آخر الأخبار والتحديثات",
    href: "#",
    icon: "x",
  },
  {
    name: "TikTok",
    description: "شاهد محتوى التدوير",
    href: "#",
    icon: "tiktok",
  },
  {
    name: "LinkedIn",
    description: "تواصل معنا مهنيًا",
    href: "#",
    icon: "linkedin",
  },
];

function SocialIcon({ type }) {
  if (type === "instagram") {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        className="h-6 w-6"
      >
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="0.7" fill="currentColor" />
      </svg>
    );
  }

  if (type === "x") {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-5 w-5"
      >
        <path d="M18.244 2H21.5l-7.11 8.13L22.75 22h-6.57l-5.145-6.73L5.14 22H1.88l7.604-8.69L1.25 2h6.737l4.65 6.15L18.244 2Zm-1.15 17.8h1.8L7.02 4.08H5.09L17.094 19.8Z" />
      </svg>
    );
  }

  if (type === "tiktok") {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-5 w-5"
      >
        <path d="M19.59 7.69a4.83 4.83 0 0 1-3.77-3.77V3h-3.44v12.24a2.9 2.9 0 1 1-2-2.75V9.02a6.34 6.34 0 1 0 5.44 6.27V9.82a8.25 8.25 0 0 0 4.83 1.56V8a4.84 4.84 0 0 1-1.06-.31Z" />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className="h-5 w-5"
    >
      <path d="M20.45 20.45h-3.56v-5.58c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.13 1.44-2.13 2.94v5.68H9.35V8.99h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.26 2.37 4.26 5.46v6.29ZM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14ZM3.56 20.45h3.57V8.99H3.56v11.46ZM22.23 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.46c.98 0 1.77-.77 1.77-1.72V1.72C24 .77 23.21 0 22.23 0Z" />
    </svg>
  );
}

export default function SocialMediaSection() {
  return (
    <section className="bg-white py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl bg-gray-50 px-6 py-12 md:px-10">
          <div className="mx-auto max-w-2xl text-center">
            <span className="text-sm font-semibold text-green-600">
              مجتمعنا
            </span>

            <h2 className="mt-3 text-3xl font-bold text-gray-900 md:text-4xl">
              تابع رحلة التدوير معنا
            </h2>

            <p className="mt-4 leading-8 text-gray-600">
              تابع أخبارنا ومشاريعنا ومحتوى التدوير، وكن جزءًا من
              مجتمع يهتم بمستقبل أكثر استدامة.
            </p>
          </div>

          <div className="mx-auto mt-10 grid max-w-4xl gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group rounded-2xl border border-gray-200 bg-white p-5 transition duration-300 hover:-translate-y-1 hover:border-green-200 hover:shadow-md"
              >
                <div className="flex items-center gap-4">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-green-50 text-green-600 transition group-hover:bg-green-600 group-hover:text-white">
                    <SocialIcon type={social.icon} />
                  </div>

                  <div className="text-right">
                    <h3 className="font-bold text-gray-900">
                      {social.name}
                    </h3>

                    <p className="mt-1 text-xs text-gray-500">
                      {social.description}
                    </p>
                  </div>
                </div>
              </a>
            ))}
          </div>

          <div className="mt-10 text-center">
            <span className="text-sm text-gray-500">
              تابعنا وكن جزءًا من التغيير 🌱
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}